<template>
  <div class="container is-fluid" id="app">
    <router-view name="main"></router-view>
    <router-view name="login"></router-view>
  </div>
</template>
<script>
export default {
  name: "app",

  data() {
    return {};
  }
};
</script>
<style lang="scss">
//Import Bulma's core
@import "~bulma/sass/utilities/_all";
@import url('https://fonts.googleapis.com/css?family=Nunito+Sans');

$family-sans-serif: "Nunito Sans", serif;
 
// Set your colors
$primary: #2b4fc5;
$primary-invert: findColorInvert($primary);
$twitter: #4099ff;
$twitter-invert: findColorInvert($twitter);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": ($white, $black),
  "black": ($black, $white),
  "light": ($light, $light-invert),
  "dark": ($dark, $dark-invert),
  "primary": ($primary, $primary-invert),
  "info": ($info, $info-invert),
  "success": ($success, $success-invert),
  "warning": ($warning, $warning-invert),
  "danger": ($danger, $danger-invert),
  "twitter": ($twitter, $twitter-invert)
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

$input-shadow: none;
$family-primary: $family-sans-serif;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>
